import React, { useEffect, useState } from 'react';
import { useGetBanners } from '@nxsys/hooks/api/dashboard/useBannerApi';
import AppBannerCarousel from '@nxsys/components/dashboard/AppBannerCarousel';
import AppActivityLogModal from '@nxsys/components/dashboard/AppActivityLogModal';
import { BannerItem } from '@nxsys/types/models/banner';

const BannerCarouselSection: React.FC = () => {
  const { value, loading, error, run: fetchBanners } = useGetBanners();
  const [selectedBanner, setSelectedBanner] = useState<BannerItem | null>(null);
  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    fetchBanners();
  }, []);

  const banners = value?.data ?? [];

  // Empty - return null
  if (banners.length === 0 || loading || error || !value?.success) {
    return null;
  }

  // Handle banner click
  const handleBannerClick = (banner: BannerItem) => {
    setSelectedBanner(banner);
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedBanner(null);
  };

  return (
    <>
      <div style={{ marginBottom: '24px' }}>
        <AppBannerCarousel
          banners={banners}
          onBannerClick={handleBannerClick}
        />
      </div>

      <AppActivityLogModal
        visible={modalVisible}
        banner={selectedBanner}
        onClose={handleCloseModal}
      />
    </>
  );
};

export default BannerCarouselSection;
